import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as DevModules from 'devextreme-angular';

import { DynamicFilterComponent } from './component/dynamic-filter.component';

@NgModule({
   imports: [
      CommonModule,
      DevModules.DxButtonModule,
      DevModules.DxFormModule,
      DevModules.DxPopupModule,
      DevModules.DxScrollViewModule
   ],
   exports: [
      DynamicFilterComponent
   ],
   declarations: [
      DynamicFilterComponent
   ],
   entryComponents: [],
   providers: []
})
export class DynamicFilterModule { }
